<template>
  <div class="auth-page" :style="clientColor ? { '--brand-color': clientColor } : null">
    <header class="top-bar">
      <div class="brand-pill" :style="{ backgroundColor: logoBackgroundColor }">
        <img v-if="clientLogo"
             :src="clientLogo"
             alt="Client Logo"
             class="brand-image" />
        <img v-else
             src="@/../public/static/img/acrew-logo-with-effects-white.png"
             alt="ACREW Logo"
             class="brand-image default" />
      </div>
      <div class="top-login">
        <img src="@/../public/static/img/acrew-dash-pattern.png" alt="" class="dash-pattern" />
        <span>Login</span>
      </div>
    </header>
    <div class="content-area" fluid>
      <div class="card-wrapper">
        <div class="auth-card">
          <div class="heading">
            <div class="heading-text">
              <h2 v-if="tokenValid && !updateSuccess">Enter a new password</h2>
              <h2 v-if="updateSuccess">Your password has been changed!</h2>
              <h2 v-if="!tokenValid">Reset Link Expired</h2>
            </div>
          </div>
          <div v-if="isSubmitting" class="loading-overlay">
            <v-progress-circular indeterminate color="primary" size="50" />
          </div>
          <v-form ref="form" @submit.prevent="submit">
            <div v-if="tokenValid && !updateSuccess">
              <v-text-field v-model="password"
                            ref="passwordField"
                            label="New Password"
                            type="password"
                            :rules="[rules.required, rules.pass_all, rules.max50]"
                            validate-on-blur
                            required
                            class="line-input custom-filled"
                            dense
                            hide-details="auto" />
              <v-text-field v-model="confirmPassword"
                            label="Repeat Password"
                            class="line-input custom-filled"
                            type="password"
                            :rules="[
                                rules.required,
                                rules.pass_all,
                                rules.max50,
                                mustMatch,
                              ]"
                            validate-on-blur
                            required
                            dense
                            hide-details="auto" />
              <v-btn class="btn-primary full-width-btn" type="submit" :disabled="isSubmitting">
                Submit
              </v-btn>
            </div>
            <div v-if="updateSuccess">
              <v-btn @click="$router.push('/login')" class="btn-primary full-width-btn">
                Return to Login
              </v-btn>
            </div>
            <div v-if="!tokenValid">
              <p class="error-message">This password reset link has expired or is no longer valid.</p>
              <p class="help-text">Please request a new password reset link to continue.</p>
              <div class="button-row">
                <v-btn @click="$router.push('/forgot_password')" class="btn-primary">
                  Request New Link
                </v-btn>
                <v-btn @click="$router.push('/login')" class="btn-secondary">
                  Return to Login
                </v-btn>
              </div>
            </div>
          </v-form>
        </div>
      </div>
    </div>
    <div v-if="clientColor" class="powered-by">
      <span>BROUGHT TO YOU BY</span>
      <img src="@/../public/static/img/acrew-logo-with-effects.png" alt="Logo" />
    </div>
  </div>
</template>
<style scoped lang="scss">
  /** ResetPassword.vue */
  @import '@/scss/variables.scss';
  @import '@/scss/auth/page.scss';

  .full-width-btn {
    width: 100%;
    margin-top: 5px;
  }
</style>
<script>
import DataService from '../../_services/DataService';
import ValidateService from '../../_services/ValidateService';
import { loadClientPreferences } from '../utils/UxUtils';

export default {
  name: 'ResetPassword',
  data() {
    return {
      clientLogo: null,
      clientColor: null,
      whiteBehindLogo: false,
      password: '',
      confirmPassword: '',
      tokenValid: false,
      updateSuccess: false,
      isSubmitting: false,
      rules: ValidateService.validators,
    };
  },
  computed: {
    logoBackgroundColor() {
      return this.whiteBehindLogo ? 'white' : (this.clientColor || '#11405c');
    },
  },
  methods: {
    mustMatch() {
      return this.password === this.confirmPassword ? true : 'Passwords do not match.';
    },
    async submit() {
      if (this.isSubmitting) return;
      
      if (!this.$refs.form || !this.$refs.form.validate()) {
        return;
      }
      
      this.isSubmitting = true;
      
      try {
        const body = {
          username: this.username,
          token: this.$route.query.token,
          password: this.password,
        };
        
        const response = await DataService.changePassword(body);
        
        this.tokenValid = response.data.validToken;
        this.updateSuccess = response.data.success;
        
        if (this.updateSuccess) {
          this.$root.$emit('raise_alert', { color: 'success', text: 'Password changed successfully!' });
        } else {
          this.$root.$emit('raise_alert', { color: 'error', text: 'Failed to change password. Please try again.' });
        }
      } catch (error) {
        this.$root.$emit('raise_alert', { color: 'error', text: 'Network error. Please try again.' });
      } finally {
        this.isSubmitting = false;
      }
    },
  },
  async created() {
    try {
      const token = this.$route.query.token;
      const data = await DataService.checkPasswordResetToken({ token });
      this.tokenValid = data.data.validToken;
    } catch (error) {
      this.$root.$emit('raise_alert', { color: 'error', text: 'Failed to validate token.' });
      this.tokenValid = false;
    }
  },
  async mounted() {
    try {
      if (this.$route.query.clientId) {
        DataService.updateClientId(this.$route.query.clientId);
      }
      
      await loadClientPreferences(this);
    } catch (error) {
      this.$root.$emit('raise_alert', { color: 'error', text: 'Failed to initialize. Please refresh the page.' });
    }
  },
};
</script>
